<template>
  <v-container style="background-color: #F0F0EF;">
    <v-row>
      <v-col
        cols="8"
        sm="4"
        style="padding: 0px; height: 42px"
        class="pl-1 d-flex flex-column align-start"
      >
        <label for="label" class="font">{{ $tc("Label") }} *</label>
        <v-text-field
          style="width: 184px;"
          :value="receivedData.label"
          v-model="receivedData.label"
          color="#4fa2b7"
          clearable
          height="25"
          required
          :rules="rules"
          :disabled="disableLabel"
        />
      </v-col>
      <v-col
        cols="4"
        sm="4"
        style="padding: 0px"
        class="d-flex flex-column align-start"
      >
        <label for="label" class="font">{{ $tc("Priority") }} *</label>
        <v-autocomplete
          style="width: 184px;"
          :items="priorities"
          height="25"
          color="#4fa2b7"
          item-text="label"
          item-value="uuid"
          return-object
          :rules="rules"
          :value="receivedData.priority"
          v-model="receivedData.priority"
          :disabled="disabledView"
          onkeypress="return false;"
        />
      </v-col>
      <v-col
        cols="4"
        sm="4"
        style="padding: 0px"
        class="d-flex flex-column align-start"
      >
        <label for="label" class="font">{{ $tc("ApprovalType") }}</label>
        <v-autocomplete
          style="width: 184px;"
          :items="approvalType"
          height="25"
          color="#4fa2b7"
          :value="automaticApproval"
          item-text="title"
          item-value="value"
          @input="setApproval($event)"
          :disabled="disabledView || selectedTemplates.length <= 0"
          onkeypress="return false;"
        />
      </v-col>
      <v-col
        cols="8"
        sm="4"
        style="padding: 0px"
        class="pl-1 d-flex flex-column align-start"
      >
        <label for="label" class="font">{{ $tc("StartDate") }} *</label>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="receivedData.start_date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              style="width: 184px;"
              v-model="receivedData.start_date"
              color="#4fa2b7"
              :value="receivedData.start_date"
              append-icon="mdi-calendar"
              height="25"
              :rules="rules"
              v-bind="attrs"
              v-on="on"
              clearable
              :disabled="disabledView"
              onkeypress="return false;"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="receivedData.start_date"
            no-title
            scrollable
            @input="$refs.menu.save(receivedData.start_date)"
            :min="disableDateBeforeStartDate"
            :max="disableDateAfterEndDate"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="8"
        sm="4"
        style="padding: 0px"
        class="d-flex flex-column align-start"
      >
        <label for="label" class="font">{{ $tc("ExpectedEndDate") }} *</label>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          :return-value.sync="receivedData.end_date"
          :value="receivedData.end_date"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              style="width: 184px;"
              v-model="receivedData.end_date"
              append-icon="mdi-calendar"
              :value="receivedData.end_date"
              height="25"
              color="#4fa2b7"
              :rules="rules"
              v-bind="attrs"
              v-on="on"
              clearable
              :disabled="disabledView"
              onkeypress="return false;"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="receivedData.end_date"
            no-title
            scrollable
            :picker-date.sync="dateStart"
            @input="$refs.menu1.save(receivedData.end_date)"
            :min="disableDateBeforeStartDate"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col
        cols="8"
        sm="4"
        style="padding: 0px"
        class="d-flex flex-column align-start"
      >
        <label for="label" class="font">{{ $tc("FinishDate") }}</label>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          :return-value.sync="receivedData.finishDate"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              style="width: 184px;"
              v-model="receivedData.finishDate"
              append-icon="mdi-calendar"
              height="25"
              color="#4fa2b7"
              readonly
              :rules="rules"
              v-bind="attrs"
              v-on="on"
              clearable
              :disabled="true"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="receivedData.finishDate"
            @input="$refs.menu2.save(receivedData.finishDate)"
            :min="disableDateBeforeStartDate"
          >
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-divider class="mt-4"></v-divider>
    <work-order-detail-templates
      :receivedData="receivedData"
      :action-type="actionType"
      @objectTemplates="$emit('objectTemplates', $event)"
      :disabledView="disabledView"
    />
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import WorkOrderDetailTemplates from "./WorkOrderDetailTemplates.vue";
export default {
  name: "workOrderFormDetails",

  components: {
    WorkOrderDetailTemplates
  },

  props: {
    receivedData: {
      type: Object
    },
    disabledView: {
      type: Boolean
    },
    actionType: {
      type: String
    }
  },

  data() {
    return {
      priorities: [],
      dateStart: null,
      rules: [value => !!value || "Required"],
      menu: false,
      menu1: false,
      menu2: false
    };
  },
  /**
   * gets the priority list from back end to send with specific uuid
   */
  mounted() {
    this.getPriorityLists();
  },
  /**
   * attributes start_date value to dateStart variable, this varible is used in the date picker with the .sync.
   */
  watch: {
    "receivedData.start_date"(value) {
      this.dateStart = value;
    }
  },

  computed: {
    /**
     * fetches selected templates from store.
     */
    selectedTemplates() {
      return this.$store.state.workOrders.selectedTemplates;
    },
    disableLabel() {
      return (this.actionType === "view" || this.actionType === "edit");
    },
    /**
     * if when editing if every item is true returns the corresponding selected title
     */
    automaticApproval() {
      let found = null;
      if (this.actionType) {
        this.receivedData.activities.forEach(item => {
          found = item.tasks.every(item => item.auto_approval === true);
        });
      }
      return found;
    },

    /**
     * list of approval types
     */
    approvalType() {
      return [
        {
          title: this.$i18n.t("Automatic"),
          value: null,
          disabled: this.actionType
        },
        {
          title: this.$i18n.t("AutoApproved"),
          value: true
        },
        {
          title: this.$i18n.t("ManualApproval"),
          value: false
        }
      ];
    },
    /**
     * If there is a startDate, all dates before that should be disabled, if there is no start date, all dates before today
     * should be disabled.
     */
    disableDateBeforeStartDate() {
      let dateTime = new Date();
      if (this.receivedData.start_date) {
        return this.receivedData.start_date;
      }
      return dateTime.toISOString().split("T")[0];
    },

    /**
     * If there is a endDate, all dates after that should be disabled
     */
    disableDateAfterEndDate() {
      if (this.receivedData.end_date) {
        return this.receivedData.end_date;
      } else return null;
    }
  },

  methods: {
    ...mapActions(["priorityLists"]),

    /**
     * request for priorities
     */
    async getPriorityLists() {
      try {
        this.loading = true;
        this.priorities = await this.priorityLists();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * if the selected approval is automatic, all tasks are filled with auto approval from the template
     * else all of them are filled with the selected value (true or false)
     */
    setApproval(selected) {
      let automatic;
      if (selected === null) {
        this.selectedTemplates.forEach(item => {
          item.tasks.forEach(task => {
            automatic = task.auto_approval;
          });
        });
      }
      this.receivedData.activities.forEach(item => {
        item.tasks.forEach(item => {
          if (automatic) {
            item.auto_approval = automatic;
          } else {
            item.auto_approval = selected;
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.v-input.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
  margin-bottom: 4px;
  font-size: 12px;
}
.v-input >>> .v-input__control > .v-input__slot:before,
.v-input >>> .v-input__control > .v-input__slot:after {
  border-style: solid !important;
}

.font {
  font-family: Roboto;
  font-weight: regular;
  font-size: 9px;
  color: #666666;
  letter-spacing: 8;
  margin-bottom: 5px;
}
.v-autocomplete__content.v-menu__content .v-select-list {
  width: 261px;
  text-align: left;
}
.v-text-field >>> input {
  cursor: pointer;
}
.v-text-field >>> .v-input__icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/WorkOrderDetails.vue